









































import { Component, Vue } from "vue-property-decorator";
import { APIError, NotFoundError } from "@/services/error_service";
import { Collection } from "@/models/products/collection";
import { ProductType } from "@/models/products/product";
import ProductService from "@/services/product_service";
import { UmbrellaType } from "@/models/products/umbrella";
import { mixins } from "vue-class-component";
import { LayoutStore } from "@/mixins/store";

@Component
export default class QuickShipProductLines extends mixins(LayoutStore) {
  protected umbrellas: Collection[] = [];
  protected productService = new ProductService();
  protected UmbrellaType = UmbrellaType;

  async created() {
    // this.umbrellas = await this.getProductLines();
    this.$router.push(
      `/quickship/${this.collection.handle.replace(/_/g, "-")}`
    );
  }

  protected umbrellasFiltered(type: UmbrellaType) {
    return this.umbrellas.filter(umbrella => umbrella.umbrella_type === type);
  }

  protected getImg(handle: string, type: UmbrellaType): string {
    // let img = "https://via.placeholder.com/250x165";
    // if (type === UmbrellaType.Market) {
    //   img = require(`../../assets/images/${handle}.png`); // "require" is needed because of webpack issue with compiling dynamic image urls
    // }
    // return img;
    return (
      process.env.VUE_APP_CDN_URL +
      `/products/productlines/withtext/${handle}.png`
    );
  }

  protected selectUrl(handle: string): string {
    return handle.replace(/_/g, "-");
  }
  protected async getProductLines(): Promise<Collection[]> {
    let umbrellas: Collection[] = [];
    try {
      const res = await this.productService.getProducts({
        category: ProductType.Umbrella,
        sort: "productline"
      });
      umbrellas = res;
    } catch (err) {
      if (err instanceof NotFoundError) {
        NotFoundError.popup(err.message, err.statusCode);
      } else {
        APIError.popup(err.message, err.statusCode);
      }
    }
    return umbrellas;
  }
}
